import { useState } from 'react';
import { useEffect } from 'react';
import ReactSelect from 'react-select';
import Fetch from '../../../../../../util/core/Fetch';

function Select(props) {
    let [value, updateValue] = useState(props.value);
    let [options, updateOptions] = useState(props.options);
    let [readOnly, setReadOnly] = useState(false);
    let [sort] = useState(
        typeof props.sort === 'undefined' ? 'ASC' : props.sort
    );
    let customStyle = {};
    let className = '';

    useEffect(() => {
        const loadOptions = async () => {
            let option = options.filter(
                (selected) => selected.value == value.value
            );
            if (props.value) {
                updateValue(props.value);
            } else {
                updateValue(option);
            }

            if (props.optionsEndpoint && props.optionsEndpoint.endpoint) {
                const defaultOptionsEndpoint = {
                    lat: 'lat',
                    lng: 'lng',
                    fullAddress: 'fullAddress',
                    ...props.optionsEndpoint
                };

                let url = defaultOptionsEndpoint.endpoint;
                let keyLabel = defaultOptionsEndpoint.label;
                let keyValue = defaultOptionsEndpoint.value;
                let keyLat = defaultOptionsEndpoint.lat;
                let keyLng = defaultOptionsEndpoint.lng;
                let keyFullAddress = defaultOptionsEndpoint.fullAddress;
                let keyJson = defaultOptionsEndpoint.fieldJsonAddress;
                const params = defaultOptionsEndpoint.params
                    ? defaultOptionsEndpoint.params
                    : {};
                let rows = await Fetch.post(url, params);

                let tempOptions = rows.map((item) => ({
                    value: item[keyValue],
                    label: item[keyLabel],
                    lat: keyJson ? item[keyJson][keyLat] : item[keyLat],
                    lng: keyJson ? item[keyJson][keyLng] : item[keyLng],
                    fullAddress: keyJson
                        ? item[keyJson][keyFullAddress]
                        : item[keyFullAddress]
                }));

                option = tempOptions.filter(
                    (selected) => selected.value == value.value
                );

                if(sort){
                    tempOptions.sort((a, b) => {
                      const labelA = a.label?a.label:'';
                      const labelB = b.label?b.label:'';
                      let fa = labelA.toLowerCase(),
                      fb = labelB.toLowerCase();
                      if (fa < fb) {
                          return -1;
                      }
                      if (fa > fb) {
                          return 1;
                      }
                      return 0;
                    });
          
                    if(sort == 'DESC'){
                      tempOptions = tempOptions.reverse()
                    }
                }

                updateOptions(tempOptions);
                updateValue(option);

                if (
                    tempOptions.length === 1 &&
                    props.canAutoFill &&
                    props.required
                ) {
                    updateValue(tempOptions[0]);
                    handleChange(tempOptions[0]);
                    setReadOnly(true);
                }
            }
        };
        loadOptions();
    }, [props.value]);

    const handleChange = (element) => {
        const target = {
            name: props.name,
            type: 'select',
            ...element
        };
        updateValue(element);
        props.onChange({ target: target });
    };

    if (props.error) {
        className = 'is-invalid';
        customStyle = { border: '1px solid #dc3545' };
    }

    return (
        <div>
            <div style={customStyle}>
                <ReactSelect
                    autoFocus={props.autoFocus ? true : false}
                    isClearable={false}
                    name={props.name}
                    placeholder={
                        props.placeholder ? props.placeholder : 'Selecione'
                    }
                    options={options}
                    onChange={handleChange}
                    value={value}
                    isDisabled={props.disabled}
                    isSearchable={!readOnly}
                    menuIsOpen={readOnly ? false : undefined}
                />
            </div>
        </div>
    );
}
export default Select;
